import React from 'react';
import {
    PerformanceSection, PerformanceHeadingWrapper, PerformanceSectionHeading,
    PerformanceHeadingPara, PerformanceHolder, PerformanceCount, PerformanceDetails
} from './performance.style';
import { Container, Row, Col } from '@bootstrap-styled/v4';
import Fade from 'react-reveal/Fade';
import { useStaticQuery, graphql } from 'gatsby';

const Performance = () => {
    const JSONData = useStaticQuery(graphql`
        query{
            saasJson {
                Performance {
                    DelayConstant
                    PerformanceSectionHeading
                    PerformanceHeadingPara
                    Row{
                        PerformanceCount
                        PerformanceDetails
                    }
                }
            }
        }
    `);
    return (
        <PerformanceSection id="performanceContainer">
            <Container>
                <Row>
                    <Col md="12">
                        <PerformanceHeadingWrapper>
                            <Fade bottom delay={1 * JSONData.saasJson.Performance.DelayConstant}>
                                <PerformanceSectionHeading>
                                    Developed in Australia
                                </PerformanceSectionHeading>
                            </Fade>
                            <Fade bottom delay={2 * JSONData.saasJson.Performance.DelayConstant}>
                                <PerformanceHeadingPara>
                                    DocKeeper is an industry non-specific responsibility management software that has been designed to help you collect data in an automated way. This platform is fashioned to help you track key documents such as driver’s license, premits and insurances automatically. As a booking entity, you are the first point of audit. It is therefore imperative that you ensure that contacts registered under you are in total compliance with the requirements starting from qualification to the possession of the key documents required to operate.
                            </PerformanceHeadingPara>
                                <PerformanceHeadingPara>
                                    With DocKeeper, the onus is on the on the supplier, employee or client to update their own key documents. It is, therefore, no gainsaying that DocKeeper was designed to cater for Chain of Responsibility and ensure that client companies are rescued from the heavy punishments -ranging from whopping fines to imprisonment- that await them if non-compliance is observed.
                            </PerformanceHeadingPara>
                            </Fade>
                        </PerformanceHeadingWrapper>
                    </Col>
                </Row>
                <Row>
                    {/* { 
                    JSONData.saasJson.Performance.Row.map((item,idx) => {
                    return <Col md="3" sm="6">
                        <Fade bottom delay={(idx+1)*JSONData.saasJson.Performance.DelayConstant}>
                            <PerformanceHolder>
                                <PerformanceCount>
                                    {item.PerformanceCount}
                                </PerformanceCount>
                                <PerformanceDetails>
                                    {item.PerformanceDetails}
                                </PerformanceDetails>
                            </PerformanceHolder>
                        </Fade>
                    </Col>
                    })
                } */}
                </Row>
            </Container>
        </PerformanceSection>
    );
}

export default Performance;